
// // import { useEffect, useState } from "react"
// // import {
// //   Box,
// //   Button,
// //   Paper,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   CircularProgress,
// //   Menu,
// //   MenuItem,
// // } from "@mui/material"
// // import { styled } from "@mui/material/styles"
// // import Swal from "sweetalert2"
// // import Confetti from "react-confetti"
// // import { keyframes } from "@mui/system"

// // // Import logo images
// // import Logo1 from "../landpageimage1/destinationlogo.png"
// // import Logo2 from "../../src/landpageimage/TDTLLogo.png"
// // import Logo3 from '../landpageimage1/mitlogo.jpg'
// // import Logo4 from '../landpageimage1/startuplogo.png'

// // // Keyframes for animations
// // const pulseGlow = keyframes`
// //   0% { opacity: 0.8; filter: brightness(1); }
// //   50% { opacity: 1; filter: brightness(1.2); }
// //   100% { opacity: 0.8; filter: brightness(1); }
// // `

// // const rotateRays = keyframes`
// //   from { transform: rotate(0deg); }
// //   to { transform: rotate(360deg); }
// // `

// // const scoreReveal = keyframes`
// //   0% { transform: scale(0); opacity: 0; }
// //   50% { transform: scale(1.2); opacity: 0.8; }
// //   100% { transform: scale(1); opacity: 1; }
// // `

// // const flashScore = keyframes`
// //   0% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
// //   33% { color: #ff00ff; text-shadow: 0 0 20px #ff00ff; }
// //   66% { color: #ffff00; text-shadow: 0 0 20px #ffff00; }
// //   100% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
// // `

// // const themeColors = {
// //   primary: "#FF6B00",
// //   secondary: "#FF9D45",
// //   gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",

// //   lightOrange: "#FFF3E0",
// // }

// // const StyledPaper = styled(Paper)(() => ({
// //   display: "flex",
// //   flexDirection: "column",
// //   alignItems: "center",
// //   width: "90%",
// //   maxWidth: "800px",
// //   margin: "0 auto",
// //   borderRadius: "24px",
// //   padding: "24px",
// //   backgroundColor: "#FFFFFF",
// //   boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
// // }))

// // const LogoContainer = styled(Box)(() => ({
// //   display: "grid",
// //   gridTemplateColumns: "repeat(4, 1fr)",
// //   gap: "16px",
// //   justifyContent: "center",
// //   alignItems: "center",
// //   width: "100%",
// //   padding: "16px 0",
// //   marginBottom: "16px",
// //   "@media (max-width: 600px)": {
// //     gridTemplateColumns: "repeat(2, 1fr)",
// //   },
// // }))

// // const LogoImage = styled("img")(() => ({
// //   maxWidth: "100px",
// //   maxHeight: "80px",
// //   objectFit: "contain",
// //   margin: "0 auto",
// // }))

// // function NeonTimer({ timeLeft, finalScore, onTimerComplete }) {
// //   const [showScore, setShowScore] = useState(false)

// //   useEffect(() => {
// //     if (timeLeft <= 0) {
// //       setShowScore(true)
// //       setTimeout(() => {
// //         onTimerComplete()
// //       }, 5000)
// //     }
// //   }, [timeLeft, onTimerComplete])

// //   const formatTime = (time) => {
// //     const minutes = Math.floor(time / 60)
// //     const seconds = time % 60
// //     return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
// //   }

// //   return (
// //     <Box
// //       sx={{
// //         width: "100vw",
// //         height: "100vh",
// //         background: "#000000",
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         position: "fixed",
// //         top: 0,
// //         left: 0,
// //         zIndex: 9999,
// //       }}
// //     >
// //       <Box
// //         sx={{
// //           position: "absolute",
// //           width: "800px",
// //           height: "800px",
// //           "&::before": {
// //             content: '""',
// //             position: "absolute",
// //             width: "100%",
// //             height: "100%",
// //             background: "repeating-conic-gradient(from 0deg, transparent 0deg, #ffffff1a 1deg, transparent 2deg)",
// //             animation: `${rotateRays} 60s linear infinite`,
// //             borderRadius: "50%",
// //           },
// //         }}
// //       />
// //       <Box
// //         sx={{
// //           position: "absolute",
// //           width: "600px",
// //           height: "600px",
// //           borderRadius: "50%",
// //           background: "radial-gradient(circle, #ffffff33 0%, transparent 70%)",
// //           animation: `${pulseGlow} 2s ease-in-out infinite`,
// //         }}
// //       />

// //       <Box
// //         sx={{
// //           position: "relative",
// //           zIndex: 2,
// //           background: "radial-gradient(circle, #ffffff1a 0%, transparent 100%)",
// //           padding: "60px",
// //           borderRadius: "50%",
// //           width: "500px",
// //           height: "500px",
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //         }}
// //       >
// //         {!showScore ? (
// //           <Box
// //             sx={{
// //               fontFamily: "'Orbitron', sans-serif",
// //               fontSize: "6rem",
// //               color: "#ffffff",
// //               textShadow: `
// //                 0 0 5px #ffffff,
// //                 0 0 10px #ffffff,
// //                 0 0 20px #ffffff,
// //                 0 0 40px #ffffff,
// //                 0 0 80px #ffffff
// //               `,
// //               animation: `${pulseGlow} 2s ease-in-out infinite`,
// //               letterSpacing: "2px",
// //             }}
// //           >
// //             {formatTime(timeLeft)}
// //           </Box>
// //         ) : (
// //           <Box
// //             sx={{
// //               animation: `${scoreReveal} 0.5s ease-out forwards, ${flashScore} 2s infinite`,
// //               fontSize: "5rem",
// //               fontWeight: "bold",
// //               textAlign: "center",
// //               fontFamily: "'Orbitron', sans-serif",
// //               color: "#ffffff",
// //             }}
// //           >
// //             <Box sx={{ fontSize: "3rem", marginBottom: "20px" }}>FINAL SCORE</Box>
// //             <Box sx={{ fontSize: "6rem" }}>{finalScore}</Box>
// //           </Box>
// //         )}
// //       </Box>
// //       {Array.from({ length: 36 }).map((_, index) => (
// //         <Box
// //           key={index}
// //           sx={{
// //             position: "absolute",
// //             width: "3px",
// //             height: "400px",
// //             background: "linear-gradient(to top, transparent, #ffffff33)",
// //             transformOrigin: "bottom center",
// //             transform: `rotate(${index * 10}deg)`,
// //             left: "calc(50% - 1.5px)",
// //             bottom: "50%",
// //             opacity: 0.5,
// //           }}
// //         />
// //       ))}
// //     </Box>
// //   )
// // }

// // export default function CheckScore() {
// //   const [data, setData] = useState([])
// //   const [loading, setLoading] = useState(true)
// //   const [scoreLoading, setScoreLoading] = useState(false)
// //   const [confetti, setConfetti] = useState(false)
// //   const [showTimer, setShowTimer] = useState(false)
// //   const [timeLeft, setTimeLeft] = useState(30)
// //   const [currentScore, setCurrentScore] = useState(null)
// //   const [contextMenu, setContextMenu] = useState(null)
// //   const [selectedId, setSelectedId] = useState(null)

// //   useEffect(() => {
// //     fetch("https://puneexpobackend.tdtlworld.com/api/basic_idea_info/")
// //       .then((response) => response.json())
// //       .then((result) => {
// //         setData(result)
// //         setLoading(false)
// //       })
// //       .catch((error) => {
// //         Swal.fire("Error", "Failed to fetch data", "error")
// //         setLoading(false)
// //       })
// //   }, [])

// //   useEffect(() => {
// //     let timer
// //     if (showTimer && timeLeft > 0) {
// //       timer = setInterval(() => {
// //         setTimeLeft((prev) => {
// //           if (prev <= 1) {
// //             clearInterval(timer)
// //             return 0
// //           }
// //           return prev - 1
// //         })
// //       }, 1000)
// //     }
// //     return () => clearInterval(timer)
// //   }, [showTimer, timeLeft])

// //   const handleCheckScore = (id) => {
// //     setSelectedId(id)
// //     setShowTimer(true)
// //     setScoreLoading(true)
// //     setTimeLeft(3)

// //     fetch("https://puneexpobackend.tdtlworld.com/api/score_calculation/", {
// //       method: "POST",
// //       headers: {
// //         "Content-Type": "application/json",
// //       },
// //       body: JSON.stringify({ id }),
// //     })
// //       .then((response) => response.json())
// //       .then((result) => {
// //         const increasedScore = Math.min(result.average_feedback_score * 1.1, 100)
// //         setCurrentScore(Math.round(increasedScore))
// //         setConfetti(true)
// //         setTimeout(() => setConfetti(false), 5000)
// //       })
// //       .catch((error) => {
// //         Swal.fire("Error", "Failed to fetch score", "error")
// //       })
// //       .finally(() => {
// //         setScoreLoading(false)
// //       })
// //   }

// //   const handleTimerComplete = () => {
// //     setTimeout(() => {
// //       setShowTimer(false)
// //       setTimeLeft(30)
// //     }, 20000)
// //   }

// //   const handleContextMenu = (event, id) => {
// //     event.preventDefault()
// //     setSelectedId(id)
// //     setContextMenu(contextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 } : null)
// //   }

// //   const handleCloseContextMenu = () => {
// //     setContextMenu(null)
// //   }

// //   const handleMenuItemClick = (action) => {
// //     handleCloseContextMenu()
// //     if (action === "checkScore") {
// //       handleCheckScore(selectedId)
// //     }
// //     // Add more actions as needed
// //   }

// //   // Add custom font styles
// //   const style = document.createElement("style")
// //   style.textContent = `
// //   @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');
// //   * {
// //     margin: 0;
// //     padding: 0;
// //     box-sizing: border-box;
// //   }
// //   body {
// //     overflow-x: hidden;
// //   }
// // `
// //   document.head.appendChild(style)

// //   return (
// //     <Box
// //       sx={{
// //         minHeight: "100vh",
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         background: themeColors.background,
// //         padding: "16px",
// //       }}
// //     >
// //       {confetti && <Confetti />}
// //       {showTimer && <NeonTimer timeLeft={timeLeft} finalScore={currentScore} onTimerComplete={handleTimerComplete} />}
// //       <StyledPaper>
// //         <LogoContainer>
// //           <LogoImage src={Logo1} alt="Logo 1" />
// //           <LogoImage src={Logo2} alt="Logo 2" />
// //           <LogoImage src={Logo3} alt="Logo 3" />
// //           <LogoImage src={Logo4} alt="Logo 4" />
// //         </LogoContainer>

// //         {loading ? (
// //           <CircularProgress />
// //         ) : (
// //           <TableContainer>
// //             <Table>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell>Title</TableCell>
// //                   <TableCell>Action</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {data.map((item) => (
// //                   <TableRow
// //                     key={item.id}
// //                     onContextMenu={(e) => handleContextMenu(e, item.id)}
// //                     style={{ cursor: "context-menu" }}
// //                   >
// //                     <TableCell>{item.title}</TableCell>
// //                     <TableCell>
// //                       <Button
// //                         variant="contained"
// //                         onClick={() => handleCheckScore(item.id)}
// //                         disabled={scoreLoading || showTimer}
// //                       >
// //                         {scoreLoading && selectedId === item.id ? "Checking..." : "Check Score"}
// //                       </Button>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         )}
// //       </StyledPaper>
// //       <Menu
// //         open={contextMenu !== null}
// //         onClose={handleCloseContextMenu}
// //         anchorReference="anchorPosition"
// //         anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
// //       >
// //         <MenuItem onClick={() => handleMenuItemClick("checkScore")}>Check Score</MenuItem>
// //         {/* Add more menu items as needed */}
// //       </Menu>
// //     </Box>
// //   )
// // }
// import { useEffect, useState } from "react"
// import {
//   Box,
//   Button,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   CircularProgress,
//   Menu,
//   MenuItem,
// } from "@mui/material"
// import { styled } from "@mui/material/styles"
// import Swal from "sweetalert2"
// import Confetti from "react-confetti"
// import { keyframes } from "@mui/system"

// // Import logo images
// import Logo1 from "../landpageimage1/destinationlogo.png"
// import Logo2 from "../../src/landpageimage/TDTLLogo.png"
// import Logo3 from "../landpageimage1/mitlogo.jpg"
// import Logo4 from "../landpageimage1/startuplogo.png"

// // Keyframes for animations
// const pulseGlow = keyframes`
//   0% { opacity: 0.8; filter: brightness(1); }
//   50% { opacity: 1; filter: brightness(1.2); }
//   100% { opacity: 0.8; filter: brightness(1); }
// `

// const rotateRays = keyframes`
//   from { transform: rotate(0deg); }
//   to { transform: rotate(360deg); }
// `

// const scoreReveal = keyframes`
//   0% { transform: scale(0); opacity: 0; }
//   50% { transform: scale(1.2); opacity: 0.8; }
//   100% { transform: scale(1); opacity: 1; }
// `

// const flashScore = keyframes`
//   0% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
//   33% { color: #ff00ff; text-shadow: 0 0 20px #ff00ff; }
//   66% { color: #ffff00; text-shadow: 0 0 20px #ffff00; }
//   100% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
// `

// const themeColors = {
//   primary: "#FF6B00",
//   secondary: "#FF9D45",
//   gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",
//   lightOrange: "#FFF3E0",
// }

// const StyledPaper = styled(Paper)(() => ({
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   width: "90%",
//   maxWidth: "800px",
//   margin: "0 auto",
//   borderRadius: "24px",
//   padding: "24px",
//   backgroundColor: "#FFFFFF",
//   boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
// }))

// const LogoContainer = styled(Box)(() => ({
//   display: "grid",
//   gridTemplateColumns: "repeat(4, 1fr)",
//   gap: "16px",
//   justifyContent: "center",
//   alignItems: "center",
//   width: "100%",
//   padding: "16px 0",
//   marginBottom: "16px",
//   "@media (max-width: 600px)": {
//     gridTemplateColumns: "repeat(2, 1fr)",
//   },
// }))

// const LogoImage = styled("img")(() => ({
//   maxWidth: "100px",
//   maxHeight: "80px",
//   objectFit: "contain",
//   margin: "0 auto",
// }))

// function NeonTimer({ timeLeft, finalScore, onTimerComplete }) {
//   const [showScore, setShowScore] = useState(false)

//   useEffect(() => {
//     if (timeLeft <= 0) {
//       setShowScore(true)
//       setTimeout(() => {
//         onTimerComplete()
//       }, 5000)
//     }
//   }, [timeLeft, onTimerComplete])

//   const formatTime = (time) => {
//     const minutes = Math.floor(time / 60)
//     const seconds = time % 60
//     return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
//   }

//   return (
//     <Box
//       sx={{
//         width: "100vw",
//         height: "100vh",
//         background: "#000000",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         zIndex: 9999,
//       }}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           width: "800px",
//           height: "800px",
//           "&::before": {
//             content: '""',
//             position: "absolute",
//             width: "100%",
//             height: "100%",
//             background: "repeating-conic-gradient(from 0deg, transparent 0deg, #ffffff1a 1deg, transparent 2deg)",
//             animation: `${rotateRays} 60s linear infinite`,
//             borderRadius: "50%",
//           },
//         }}
//       />
//       <Box
//         sx={{
//           position: "absolute",
//           width: "600px",
//           height: "600px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, #ffffff33 0%, transparent 70%)",
//           animation: `${pulseGlow} 2s ease-in-out infinite`,
//         }}
//       />

//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 2,
//           background: "radial-gradient(circle, #ffffff1a 0%, transparent 100%)",
//           padding: "60px",
//           borderRadius: "50%",
//           width: "500px",
//           height: "500px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {!showScore ? (
//           <Box
//             sx={{
//               fontFamily: "'Orbitron', sans-serif",
//               fontSize: "6rem",
//               color: "#ffffff",
//               textShadow: `
//                 0 0 5px #ffffff,
//                 0 0 10px #ffffff,
//                 0 0 20px #ffffff,
//                 0 0 40px #ffffff,
//                 0 0 80px #ffffff
//               `,
//               animation: `${pulseGlow} 2s ease-in-out infinite`,
//               letterSpacing: "2px",
//             }}
//           >
//             {formatTime(timeLeft)}
//           </Box>
//         ) : (
//           <Box
//             sx={{
//               animation: `${scoreReveal} 0.5s ease-out forwards, ${flashScore} 2s infinite`,
//               fontSize: "5rem",
//               fontWeight: "bold",
//               textAlign: "center",
//               fontFamily: "'Orbitron', sans-serif",
//               color: "#ffffff",
//             }}
//           >
//             <Box sx={{ fontSize: "3rem", marginBottom: "20px" }}>FINAL SCORE</Box>
//             <Box sx={{ fontSize: "6rem" }}>{finalScore}</Box>
//           </Box>
//         )}
//       </Box>
//       {Array.from({ length: 36 }).map((_, index) => (
//         <Box
//           key={index}
//           sx={{
//             position: "absolute",
//             width: "3px",
//             height: "400px",
//             background: "linear-gradient(to top, transparent, #ffffff33)",
//             transformOrigin: "bottom center",
//             transform: `rotate(${index * 10}deg)`,
//             left: "calc(50% - 1.5px)",
//             bottom: "50%",
//             opacity: 0.5,
//           }}
//         />
//       ))}
//     </Box>
//   )
// }

// export default function CheckScore() {
//   const [data, setData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [scoreLoading, setScoreLoading] = useState(false)
//   const [confetti, setConfetti] = useState(false)
//   const [showTimer, setShowTimer] = useState(false)
//   const [timeLeft, setTimeLeft] = useState(30)
//   const [currentScore, setCurrentScore] = useState(null)
//   const [contextMenu, setContextMenu] = useState(null)
//   const [selectedId, setSelectedId] = useState(null)

//   useEffect(() => {
//     fetch("https://puneexpobackend.tdtlworld.com/api/basic_idea_info/")
//       .then((response) => response.json())
//       .then((result) => {
//         console.log("API result:", result)
//         if (Array.isArray(result.data)) {
//           setData(result.data)
//         } else {
//           throw new Error("Expected 'data' to be an array")
//         }
//         setLoading(false)
//       })
//       .catch((error) => {
//         Swal.fire("Error", "Failed to fetch data", "error")
//         console.error("Fetch error:", error)
//         setLoading(false)
//       })
//   }, [])

//   useEffect(() => {
//     let timer
//     if (showTimer && timeLeft > 0) {
//       timer = setInterval(() => {
//         setTimeLeft((prev) => {
//           if (prev <= 1) {
//             clearInterval(timer)
//             return 0
//           }
//           return prev - 1
//         })
//       }, 1000)
//     }
//     return () => clearInterval(timer)
//   }, [showTimer, timeLeft])

//   const handleCheckScore = (id) => {
//     setSelectedId(id)
//     setShowTimer(true)
//     setScoreLoading(true)
//     setTimeLeft(3)

//     fetch("https://puneexpobackend.tdtlworld.com/api/score_calculation/", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ id }),
//     })
//       .then((response) => response.json())
//       .then((result) => {
//         const increasedScore = Math.min(result.average_feedback_score * 1.1, 100)
//         setCurrentScore(Math.round(increasedScore))
//         setConfetti(true)
//         setTimeout(() => setConfetti(false), 5000)
//       })
//       .catch((error) => {
//         Swal.fire("Error", "Failed to fetch score", "error")
//       })
//       .finally(() => {
//         setScoreLoading(false)
//       })
//   }

//   const handleTimerComplete = () => {
//     setTimeout(() => {
//       setShowTimer(false)
//       setTimeLeft(30)
//     }, 20000)
//   }

//   const handleContextMenu = (event, id) => {
//     event.preventDefault()
//     setSelectedId(id)
//     setContextMenu(contextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 } : null)
//   }

//   const handleCloseContextMenu = () => {
//     setContextMenu(null)
//   }

//   const handleMenuItemClick = (action) => {
//     handleCloseContextMenu()
//     if (action === "checkScore") {
//       handleCheckScore(selectedId)
//     }
//   }

//   // Add custom font styles
//   useEffect(() => {
//     const style = document.createElement("style")
//     style.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');
//     * {
//       margin: 0;
//       padding: 0;
//       box-sizing: border-box;
//     }
//     body {
//       overflow-x: hidden;
//     }
//   `
//     document.head.appendChild(style)
//   }, [])

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: themeColors.background,
//         padding: "16px",
//       }}
//     >
//       {confetti && <Confetti />}
//       {showTimer && <NeonTimer timeLeft={timeLeft} finalScore={currentScore} onTimerComplete={handleTimerComplete} />}
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         {loading ? (
//           <CircularProgress />
//         ) : (
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Title</TableCell>
//                   <TableCell>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {data.map((item) => (
//                   <TableRow
//                     key={item.id}
//                     onContextMenu={(e) => handleContextMenu(e, item.id)}
//                     style={{ cursor: "context-menu" }}
//                   >
//                     <TableCell>{item.title}</TableCell>
//                     <TableCell>
//                       <Button
//                         variant="contained"
//                         onClick={() => handleCheckScore(item.id)}
//                         disabled={scoreLoading || showTimer}
//                       >
//                         {scoreLoading && selectedId === item.id ? "Checking..." : "Check Score"}
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </StyledPaper>
//       <Menu
//         open={contextMenu !== null}
//         onClose={handleCloseContextMenu}
//         anchorReference="anchorPosition"
//         anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
//       >
//         <MenuItem onClick={() => handleMenuItemClick("checkScore")}>Check Score</MenuItem>
//       </Menu>
//     </Box>
//   )
// }
import { useEffect, useState } from "react"
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import Swal from "sweetalert2"
import Confetti from "react-confetti"
import { keyframes } from "@mui/system"

import Logo1 from "../landpageimage1/destinationlogo.png"
import Logo2 from "../../src/landpageimage/TDTLLogo.png"
import Logo3 from "../landpageimage1/mitlogo.jpg"
import Logo4 from "../landpageimage1/startuplogo.png"

const pulseGlow = keyframes`
  0% { opacity: 0.8; filter: brightness(1); }
  50% { opacity: 1; filter: brightness(1.2); }
  100% { opacity: 0.8; filter: brightness(1); }
`

const rotateRays = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const scoreReveal = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.2); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`

const flashScore = keyframes`
  0% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
  33% { color: #ff00ff; text-shadow: 0 0 20px #ff00ff; }
  66% { color: #ffff00; text-shadow: 0 0 20px #ffff00; }
  100% { color: #00ff00; text-shadow: 0 0 20px #00ff00; }
`

const themeColors = {
  primary: "#FF6B00",
  secondary: "#FF9D45",
  gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",
  lightOrange: "#FFF3E0",
}

const StyledPaper = styled(Paper)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "90%",
  maxWidth: "800px",
  margin: "0 auto",
  borderRadius: "24px",
  padding: "24px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
}))

const LogoContainer = styled(Box)(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "16px",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  padding: "16px 0",
  marginBottom: "16px",
  "@media (max-width: 600px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}))

const LogoImage = styled("img")(() => ({
  maxWidth: "100px",
  maxHeight: "80px",
  objectFit: "contain",
  margin: "0 auto",
}))

function NeonTimer({ timeLeft, finalScore, onTimerComplete }) {
  const [showScore, setShowScore] = useState(false)

  useEffect(() => {
    if (timeLeft <= 0) {
      setShowScore(true)
      setTimeout(() => {
        onTimerComplete()
      }, 5000)
    }
  }, [timeLeft, onTimerComplete])

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
    const seconds = time % 60
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        background: "#000000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "800px",
          height: "800px",
          "&::before": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "repeating-conic-gradient(from 0deg, transparent 0deg, #ffffff1a 1deg, transparent 2deg)",
            animation: `${rotateRays} 60s linear infinite`,
            borderRadius: "50%",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: "600px",
          height: "600px",
          borderRadius: "50%",
          background: "radial-gradient(circle, #ffffff33 0%, transparent 70%)",
          animation: `${pulseGlow} 2s ease-in-out infinite`,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          background: "radial-gradient(circle, #ffffff1a 0%, transparent 100%)",
          padding: "60px",
          borderRadius: "50%",
          width: "500px",
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!showScore ? (
          <Box
            sx={{
              fontFamily: "'Orbitron', sans-serif",
              fontSize: "6rem",
              color: "#ffffff",
              textShadow: `
                0 0 5px #ffffff,
                0 0 10px #ffffff,
                0 0 20px #ffffff,
                0 0 40px #ffffff,
                0 0 80px #ffffff
              `,
              animation: `${pulseGlow} 2s ease-in-out infinite`,
              letterSpacing: "2px",
            }}
          >
            {formatTime(timeLeft)}
          </Box>
        ) : (
          <Box
            sx={{
              animation: `${scoreReveal} 0.5s ease-out forwards, ${flashScore} 2s infinite`,
              fontSize: "5rem",
              fontWeight: "bold",
              textAlign: "center",
              fontFamily: "'Orbitron', sans-serif",
              color: "#ffffff",
            }}
          >
            <Box sx={{ fontSize: "3rem", marginBottom: "20px" }}>FINAL SCORE</Box>
            <Box sx={{ fontSize: "6rem" }}>{finalScore}</Box>
          </Box>
        )}
      </Box>
      {Array.from({ length: 36 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            width: "3px",
            height: "400px",
            background: "linear-gradient(to top, transparent, #ffffff33)",
            transformOrigin: "bottom center",
            transform: `rotate(${index * 10}deg)`,
            left: "calc(50% - 1.5px)",
            bottom: "50%",
            opacity: 0.5,
          }}
        />
      ))}
    </Box>
  )
}

export default function CheckScore() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [scoreLoading, setScoreLoading] = useState(false)
  const [confetti, setConfetti] = useState(false)
  const [showTimer, setShowTimer] = useState(false)
  const [timeLeft, setTimeLeft] = useState(30)
  const [currentScore, setCurrentScore] = useState(null)
  const [contextMenu, setContextMenu] = useState(null)
  const [selectedId, setSelectedId] = useState(null)

  useEffect(() => {
    fetch("https://puneexpobackend.tdtlworld.com/api/basic_idea_info/")
      .then((response) => response.json())
      .then((result) => {
        if (Array.isArray(result.data)) {
          setData(result.data)
        } else {
          throw new Error("Expected 'data' to be an array")
        }
        setLoading(false)
      })
      .catch((error) => {
        Swal.fire("Error", "Failed to fetch data", "error")
        console.error("Fetch error:", error)
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    let timer
    if (showTimer && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => (prev <= 1 ? 0 : prev - 1))
      }, 1000)
    }
    return () => clearInterval(timer)
  }, [showTimer, timeLeft])

  const handleCheckScore = (id) => {
    setSelectedId(id)
    setShowTimer(true)
    setScoreLoading(true)
    setTimeLeft(3)

    fetch("https://puneexpobackend.tdtlworld.com/api/score_calculation/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    })
      .then((response) => response.json())
      .then((result) => {
        setCurrentScore(Math.round(result.average_feedback_score))
        setConfetti(true)
        setTimeout(() => setConfetti(false), 5000)
      })
      .catch(() => {
        Swal.fire("Error", "Failed to fetch score", "error")
      })
      .finally(() => {
        setScoreLoading(false)
      })
  }

  const handleTimerComplete = () => {
    setTimeout(() => {
      setShowTimer(false)
      setTimeLeft(30)
    }, 20000)
  }

  const handleContextMenu = (event, id) => {
    event.preventDefault()
    setSelectedId(id)
    setContextMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 })
  }

  const handleCloseContextMenu = () => {
    setContextMenu(null)
  }

  const handleMenuItemClick = (action) => {
    handleCloseContextMenu()
    if (action === "checkScore") {
      handleCheckScore(selectedId)
    }
  }

  useEffect(() => {
    const style = document.createElement("style")
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { overflow-x: hidden; }
    `
    document.head.appendChild(style)
  }, [])

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: themeColors.background,
        padding: "16px",
      }}
    >
      {confetti && <Confetti />}
      {showTimer && <NeonTimer timeLeft={timeLeft} finalScore={currentScore} onTimerComplete={handleTimerComplete} />}
      <StyledPaper>
        <LogoContainer>
          <LogoImage src={Logo1} alt="Logo 1" />
          <LogoImage src={Logo2} alt="Logo 2" />
          <LogoImage src={Logo3} alt="Logo 3" />
          <LogoImage src={Logo4} alt="Logo 4" />
        </LogoContainer>

        {loading ? (
          <CircularProgress />
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item) => (
                  <TableRow
                    key={item.id}
                    onContextMenu={(e) => handleContextMenu(e, item.id)}
                    style={{ cursor: "context-menu" }}
                  >
                    <TableCell>{item.title}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={() => handleCheckScore(item.id)}
                        disabled={scoreLoading || showTimer}
                      >
                        {scoreLoading && selectedId === item.id ? "Checking..." : "Check Score"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </StyledPaper>
      <Menu
        open={contextMenu !== null}
        onClose={handleCloseContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
      >
        <MenuItem onClick={() => handleMenuItemClick("checkScore")}>Check Score</MenuItem>
      </Menu>
    </Box>
  )
}
